import { connect } from "react-redux";
import * as Redux from "redux";
import { selectMerchant } from "../../actions";
import ViewReport from "./component";
import { currentMerchantId } from "../../../Merchant/selectors";

export interface ViewMerchantActions {
  selectMerchant: (merchant_id: number) => void;
}

const mapStateToProps = (state: any, props: any): any => {
  return {};
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): ViewMerchantActions => {
  return {
    ...Redux.bindActionCreators({ selectMerchant }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewReport);



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReport/container.tsx